var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{attrs:{"loading":_vm.loading,"type":"success"},on:{"click":_vm.downloadOrders}},[_vm._v("导出物流单")]),_c('export-express-modal',{ref:"export"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }